import React, { useState } from 'react'
import DirectStockReceiptForm from './DirectStockReceiptForm';
import DirectStockReceiptList from './DirectStockReceiptList';

const DirectStockReceipt= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <DirectStockReceiptForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <DirectStockReceiptList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default DirectStockReceipt;